import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { UpdateContactSchema } from '@app/models/dictionaries';
import Api from '@app/services/api';

interface IParams {
  uid: string;
  data: UpdateContactSchema;
}

export const useUpdateContactQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ uid, data }: IParams) => {
      const resp = await Api.dictionaries.putContact(uid, data);
      return resp;
    },
    onSuccess: async (resp, data) => {
      await client.invalidateQueries(['getContact', data?.uid]);
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
  });
};
